module.exports = __webpack_public_path__ + "img/fashion_89.5aaad2c1.jpg";